import { InjectionToken } from '@angular/core';

import { PaymentOptionDataInterface } from '../models';

export const PAYMENT_OPTION_DATA = new InjectionToken<PaymentOptionDataInterface>('PAYMENT_OPTION_DATA');
